import * as Redux from 'redux'
import * as Constants from './constants'

export const reducer = Redux.combineReducers({
  isLoading: (state = false, {type, isLoading}) =>
    type === Constants.FORGOT_PASSWORD_SET_IS_LOADING ? isLoading : state,
  serverError: (state = false, {type, serverError}) =>
    type === Constants.FORGOT_PASSWORD_SET_SERVER_ERROR ? serverError : state,
})
